export default "__VITE_ASSET__DCaH1XIT__"